import { useMemo, useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "./SectionHeading";
import { hotTips } from "@/mocks/hotTips";

export default function HotTips() {
  const filters = useMemo(() => {
    const unique = Array.from(new Set(hotTips.map((tip) => tip.category)));
    return ["全部", ...unique];
  }, []);
  const [active, setActive] = useState("全部");

  const visibleTips = active === "全部" ? hotTips : hotTips.filter((tip) => tip.category === active);

  return (
    <section id="tips" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="知情者说"
            title="近期正在跟进的精选线索"
            description="以下内容为编辑部正在核实或已整理的线索概况。如果你对其中某一条有更多信息，欢迎补充投稿——补充线索同样可以匿名。"
          />
        </Reveal>

        <Reveal delay={60}>
          <div className="mt-8 flex flex-wrap gap-2 md:mt-10">
            {filters.map((item) => {
              const isActive = item === active;
              return (
                <button
                  key={item}
                  type="button"
                  onClick={() => setActive(item)}
                  className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {item}
                </button>
              );
            })}
          </div>
        </Reveal>

        <div className="mt-8 divide-y divide-background-200 border-y border-background-200">
          {visibleTips.map((tip, index) => (
            <Reveal key={tip.id} delay={index * 50}>
              <article className="group flex flex-col gap-4 py-6 transition-colors md:flex-row md:items-center md:gap-8 md:py-7">
                <span className="font-heading text-2xl font-black text-background-300 md:w-16 md:text-3xl">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <div className="mb-2.5 flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                      {tip.category}
                    </span>
                    <span className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                      {tip.heat}
                    </span>
                    <span className="text-xs text-foreground-500">{tip.updated}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                    {tip.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.summary}</p>
                </div>
                <a
                  href="#submit"
                  className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  补充线索
                  <i className="ri-add-line" aria-hidden="true" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        {visibleTips.length === 0 ? (
          <p className="py-12 text-center text-sm text-foreground-500">
            该分类暂无公开线索，欢迎你成为第一个投稿的人。
          </p>
        ) : null}
      </div>
    </section>
  );
}